import React from 'react';
import ContactForm from '../components/ContactForm';
import GoogleMap from '../components/GoogleMap';
import ScrollToTop from '../components/ScrollToTop';
import { FaGlassCheers, FaRegCalendarCheck, FaTableTennis, FaShuttleVan } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Transfers = () => {
    const { t } = useTranslation();

    return (
    <div className="service-page-container">
      <ScrollToTop />
      <header className="service-page-header">
        <h1>{t('transfers.headerTitle')}</h1>
        <p>{t('transfers.headerSubtitle')}</p>
      </header>

      <section className="service-details-section">
        <div className="service-details-content">
          <h2>{t('transfers.headline')}</h2>
          <p className="intro-text">
            {t('transfers.introText')}
          </p>

          <ul className="feature-list">
            <li>
              <div className="feature-icon"><FaGlassCheers /></div>
              <div className="feature-text">
                <strong>{t('transfers.welcomeDrinkTitle')}</strong>
                <span>{t('transfers.welcomeDrinkDescription')}</span>
              </div>
            </li>
            <li>
              <div className="feature-icon"><FaRegCalendarCheck /></div>
              <div className="feature-text">
                <strong>{t('transfers.courtTimeTitle')}</strong>
                <span>{t('transfers.courtTimeDescription')}</span>
              </div>
            </li>
            <li>
              <div className="feature-icon"><FaTableTennis /></div>
              <div className="feature-text">
                <strong>{t('transfers.equipmentTitle')}</strong>
                <span>{t('transfers.equipmentDescription')}</span>
              </div>
            </li>
            <li>
              <div className="feature-icon"><FaShuttleVan /></div>
              <div className="feature-text">
                <strong>{t('transfers.transfersTitle')}</strong>
                <span>{t('transfers.transfersDescription')}</span>
              </div>
            </li>
          </ul>

          <p className="conclusion-text">
            {t('transfers.conclusionText')}
          </p>
        </div>
      </section>

      <ContactForm />
      <GoogleMap />
    </div>
  );
};

export default Transfers;
